import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, Icon, Chip } from '@arnsbogroup/react-voicearchive'
import { useIntl } from "react-intl";

export default ({ order }) => {
  const [state, setState] = useState({})
  const [loading, setLoading] = useState(true)
  const { formatDate, formatTime } = useIntl()

  useEffect(() => {
    const orderPromise = fetch(`/rest/v1/order/${order.uid}?includeRelations=1`)
      .then(response => response.json())
      .then((order) => setState((state) => ({
        ...state,
        classification: order.classification,
        priority: order.priority,
        wordCount: order.word_count,
        playOutMinutes: order.play_out_minutes,
        handlingLanguage: order.language_uid,
        usage: order.orderUsageType == [] ? null : { value: order.orderUsageType.uid, label: order.orderUsageType.name },
        deadline: parseInt(order.deadline) > 0 ? `${formatDate(order.deadline * 1000)} ${formatTime(order.deadline * 1000)}` : null,
        expected: parseInt(order.expected) > 0 ? `${formatDate(order.expected * 1000)} ${formatTime(order.expected * 1000)}` : null,
        start: parseInt(order.orderusage_start) > 0 ? `${formatDate(order.orderusage_start * 1000)} ${formatTime(order.orderusage_start * 1000)}` : null,
        languagesCount: order.language_count || 0,
        medias: order.mediaTypes.map(({ name }) => name).join(', '),
        services: order.services.map(({ name }) => name).join(', '),
        countries: order.countries.map(({ name }) => name).join(', '),
        suppliersCount: order.supplier_count || order.suppliers.length || 0,
        comments: order.comments,
        complex: order.complex,
      })))

    const handoverPromise = fetch(`/rest/v1/handover?search[order_uid]=${order.uid}`)
      .then(response => response.json())
      .then((handovers) => handovers?.[0]?.uid)
      .then((handoverId) => {
        if (handoverId) {
          fetch(`/rest/v2/handover/${handoverId}?includeRelations=1`)
            .then((response) => response.json())
            .then(({ data: handover }) => setState((state) => ({ ...state, handover })))
        }
      })
      .catch((err) => {
        window.alert(err)
        console.error(err)
      })

    Promise.all([orderPromise, handoverPromise]).then(() => setLoading(false))
  }, [])

  return (
    <Card className="h-full">
      <h2 className="sr-only">Deal</h2>
      <div className="flex flex-col h-full">
        <div className="grow">
          <dl className="flex flex-wrap">
            <div className="flex-auto p-4">
              <dt className="text-sm font-semibold leading-6 text-gray-900">Deal</dt>
              <dd className="mt-1 text-base font-semibold leading-6 text-gray-900">
                { loading ? (
                  <span>Limitless</span>
                ) : (
                  <span>{ state.handover?.deal.OPPORTUNITY } { state.handover?.deal.CURRENCY_ID }</span>
                ) }
              </dd>
            </div>
            <div className="flex-none self-end p-4">
              <dt className="sr-only">Status</dt>
              <dd className="inline-flex items-center">
                <Chip state="success">{ loading ? <Loader /> : state.handover?.deal.STAGE_ID }</Chip>
              </dd>
            </div>

            { [
              ['Sales responsible', ['fas', 'user'], state.handover?.deal.responsible.NAME],
              ['Classification', ['fas', 'box'], <Chip>{ state.classification || 'None' }</Chip>],
              ['Priority', ['fas', 'chart-line'], <Chip>{ state.priority }</Chip>],
            ].map(([label, icon, value]) => (
              <div className="flex w-full flex-none gap-x-4 border-t border-gray-200 px-4 py-2 items-center">
                <dt className="flex-none flex space-x-2 w-2/3 items-center">
                  <Icon icon={icon} className="text-sm text-gray-400" aria-hidden="true" />
                  <span className="font-medium text-sm text-gray-600">{ label }</span>
                </dt>
                <dd className="text-sm font-medium leading-6 text-gray-900 w-1/3 text-right">
                  { loading ? <Loader /> : value }
                </dd>
              </div>
            )) }
          </dl>
        </div>

        <div className="border-t border-gray-200 p-4">
          <a
            href={`https://my.voicearchive.com/crm/deal/details/${order.deal_id}/`}
            target="_blank"
            className="text-sm font-semibold leading-6 text-gray-900"
          >
            Open D{ order.deal_id } <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </Card>
  )
}

const Loader = () => (
  <Icon className="animate-spin" icon={['fas', 'spinner']} />
)
